var _circle, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 43.5,
    r: 43.5,
    fill: "#2B234A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 17,
    width: 47,
    height: 47,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_129_22",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_129_22",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACV0lEQVR4nO3cW27TQBhAYadSy0UsoDvkshECD1CJIpWn7oEHxAYQArZBC0iIWwU8HmRlhKzUTpzwe0pmzpHyklgT9+vUlsdWm8bMzMzMOgEHwAPgHDgD5u173W0soAS73DxibOuUZvJyH7rbWEDpcLHc+4ixbf2h4353G4s7Gc7TzPZkaGZmZrbb4VpHNui5ax15oM9d68gDfeZaRx7ouWsdeaAPXOswMzOzfAF7ek8LfAM4Br6l15P2PdHjoY96LlgeCR0P/bEH+pPQ8dC9CS30bsZAV71fxYXQQhcVzmihiwpntNBFhTNa6KLCGS10UeGM/r+hgb2q78qwuGPyDPgJfAYeAteioNux0l2YdvzfwClwq6ktFsjLvRjC3gQ6IbdjLXfa1BQwAy4G7Hqxx0KvQCbN7LoOI8CPIbw+7DHQa5BJv9xZU1PA4xUgl7DXQY9AbjtqdqHIPzvGwfzFXgW96VhBh77ZzjxTwQZAKz7PhgzcBE6AX+l1EvpsyZTPVDAeapvPwpDTvj7tGf84YuxVz1SE/a8MxmFvUxhy2s+vPd/xZacuf1k80f88EPklcD14H6d1yAEdjB2OXBR0EPYkyMVB/yP2ZMhFQm+JPSlysdAbYk+OXDT0SOwsyMVDr8HOhlwF9AB2VuRqoJewsyNXBd25XA+7rN6kqqCvMqEzJXSmhM6U0JkSOlNCFwQ99LCLwfdI6NeKDvYqEvre8PdU353oNYZ31ZNe7g2wHwadsA+Btz1fVjPyYShyB3sfuNselyo9QV6kn/12+Ew2MzMzMzNrrqg/bFh+fjo5fd0AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSave);
export default __webpack_public_path__ + "static/media/ic_save.bff3c52a459ac635767d2cfbe0305e6f.svg";
export { ForwardRef as ReactComponent };